var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1=" <a name=\"reservation-part-extraservices\" id=\"reservation-part-extraservices\"></a>  <web-component ng-form=\"$ctrl.form\"> <div ng-repeat=\"main in $ctrl.mains\"> <winres-services heading=\"{{ main.heading }}\" name=\"services-for-main-{{ $index }}\" dest-code=\"{{ main.destCode }}\" prod-code=\"{{ main.prodCode }}\" begin-date=\"{{ main.beginDate }}\" end-date=\"{{ main.endDate }}\" passengers=\"$ctrl.passengers\" allowed-passenger-numbers=\"main.passengerNumbers\" ng-model=\"$ctrl.serviceProductLines[$index]\" ng-change=\"$ctrl.read()\"> </winres-services> <br> </div> <winres-reservation-button is-pay-button=\"true\"></winres-reservation-button> </web-component>";
var id1="winresServicesWrapper.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresServicesWrapper/winresServicesWrapper.html
// module id = 450
// module chunks = 2